import { render } from "./ProfilePicture.vue?vue&type=template&id=7cb376c3&scoped=true&ts=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts"

import "./ProfilePicture.vue?vue&type=style&index=0&id=7cb376c3&lang=scss"
import "./ProfilePicture.vue?vue&type=style&index=1&id=7cb376c3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb376c3"]])

export default __exports__